import { createFileRoute } from '@tanstack/react-router'

import { OutletFormPage } from '@/features/outlet/components/outlet-form-page'
import { outletMasterApi } from '@/features/outlet/outlet-api'

export const Route = createFileRoute('/_app/settings/outlet/$id')({
  loader: async ({ params, context }) => {
    const { id } = params
    const {
      data: { outlet },
    } = await context.qc.ensureQueryData(outletMasterApi.detail.query({ params: { id } }))

    return {
      crumb: outlet.name,
    }
  },
  component: Component,
})

function Component() {
  const navigate = Route.useNavigate()
  const { id } = Route.useParams()

  return (
    <OutletFormPage mode='update' id={id} onBack={() => navigate({ to: '/settings/outlet' })} />
  )
}
